export default "__VITE_ASSET__D7fT9Pmk__"